import { Autocomplete, Box, Button, Grid, TextField, Zoom, } from '@mui/material'
import axios from 'axios';
import { useSnackbar } from 'notistack';
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import useLayoutContext from 'src/hooks/useAuthLayout';



export default function Search() {
    const { t } = useTranslation();
    const [especialidadLista, setEspecialidadLista] = useState([])
    const [especialidadSelected, setEspecialidadSelected] = useState(null)
    const { modalOpen } = useLayoutContext()
    const { enqueueSnackbar } = useSnackbar();


    useEffect(() => {
        const recuperarDatos = async () => {
            const medicosEspecialidad = await axios.get(`https://apis.vesaliohce.com.pe/citas/medicosAllEmergencia`)
            if (medicosEspecialidad.status === 200) {

                setEspecialidadLista(medicosEspecialidad.data.reduce((arr, item) => {
                    let existe = arr.findIndex(y => y.especialidad_id === item.especialidad_id)
                    if (existe < 0) {
                        arr.push(item)
                    }
                    return arr
                }, []))
            }
        }
        recuperarDatos()
    }, [])
    useEffect(() => { console.log(modalOpen) }, [modalOpen])

    const handleFilterEspecialidad = (_, newValue) => {
        setEspecialidadSelected(newValue === null ? null : newValue.id)
    }
    const handleGuardar = async () => {
        if (especialidadSelected !== null) {
            const response = await axios.post(`https://apis.vesaliohce.com.pe/citas/getChangedEspecialidad`, {
                turnoId: modalOpen.item, especialidad: especialidadSelected
            })
            if (response.status === 200) {
                enqueueSnackbar("Correcto", {
                    variant: 'success',
                    anchorOrigin: {
                        vertical: 'top',
                        horizontal: 'right'
                    },
                    TransitionComponent: Zoom
                })
                window.location.reload()
            }
        } else {
            enqueueSnackbar("Error al cambiar de turno", {
                variant: 'error',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right'
                },
                TransitionComponent: Zoom
            })
        }

    }
    return (
        <Box>
            <Grid alignItems="center" justifyContent={"center"} container spacing={3} sx={{ p: 2 }}>
                <Grid item xs={12} lg={12} md={12}>
                    <Autocomplete
                        fullWidth
                        onChange={handleFilterEspecialidad}
                        options={especialidadLista.reduce((arr, item) => {
                            arr.push({
                                id: item.especialidad_id,
                                title: `${item.nombre}`
                            })
                            return arr
                        }, []).sort(function (a, b) {
                            if (a.title > b.title) {
                                return 1;
                            }
                            if (a.title < b.title) {
                                return -1;
                            }
                            // a must be equal to b
                            return 0;
                        })}
                        getOptionLabel={(option) => option.title}
                        isOptionEqualToValue={(option, value) => option.id === value.id}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                fullWidth
                                variant="outlined"
                                label={t('Especialidades')}
                                placeholder={t('Seleccione especialidad')}
                            />
                        )}
                    />
                </Grid>
                <Grid item xs={12} lg={12} md={12}>
                    <Button variant='contained'
                        fullWidth
                        onClick={handleGuardar}
                    >
                        Buscar
                    </Button>
                </Grid>
            </Grid>
        </Box>



    )
}
